import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CryptoTicker from "./components/CryptoTicker";
import Home from "./pages/Home";
import NewsList from "./pages/NewsList";
import NewsDetail from "./pages/NewsDetail";
import { CategoriesIndex, CategoryDetail } from "./pages/Categories";
import Community from "./pages/Community";
import CommunityPostDetail from "./pages/CommunityPostDetail";
import { Login, Register } from "./pages/Auth";
import Profile from "./pages/Profile";
import AdminDashboard from "./pages/AdminDashboard";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import About from "./pages/About";
import { ProtectedRoute, AdminRoute } from "./components/Guard";
import CoinDetail from "./pages/CoinDetail";
import CoinsIndex from "./pages/CoinsIndex";
import Contact from "./pages/Contact";
import ScrollToTop from "./components/ScrollToTop";


function Shell() {
  return (
    <div className="App">
      <ScrollToTop />
      <Navbar />
      <div className="pt-16">
        <CryptoTicker />
      </div>
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/news" element={<NewsList />} />
          <Route path="/news/:id" element={<NewsDetail />} />
          <Route path="/categories" element={<CategoriesIndex />} />
          <Route path="/categories/:slug" element={<CategoryDetail />} />
          <Route path="/community" element={<Community />} />
          <Route path="/community/:id" element={<CommunityPostDetail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/about" element={<About />} />
          <Route path="/coins/:slug" element={<CoinDetail />} />
          <Route path="/coins" element={<CoinsIndex />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
      <Toaster theme="dark" position="top-right" />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Shell />
      </AuthProvider>
    </BrowserRouter>
  );
}